class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification-popup');
    this.header = document.querySelector('.site-header__mobile-nav');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.agreedCheckbox = document.querySelector('cart-notification-popup .nt_agree');
    this.checkoutBtn = document.querySelector('cart-notification-popup #check-checkout');



    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button.close-btn"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    //this.checkoutBtn.addEventListener('click', (e) => e.preventDefault());


    this.toggleMiniCart();
    this.getCart();
    this.showUpdateCartItem();
    this.handleAgreed();
    this.handleCloseBtn();

  }


  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);


  }


  close() {

    document.body.removeEventListener('click', this.onBodyClick);
    this.notification.classList.remove('active');

  }

  toggleMiniCart() {
    this.getSectionsToRender().forEach((section => {
      let elem = document.querySelector(section.id);
      if (elem) {
        elem.addEventListener('click', (e) => {
          e.preventDefault();

          this.handleActive(elem)
        })
      }

    }));
  }

  handleActive(elem) {
    if (elem.classList.contains('active')) {
      elem.classList.remove('active');
      this.close();
    } else {
      this.open();
      elem.classList.add('active');
    }
  }

  showUpdateCartItem() {
    this.getAddToCartButtons().forEach((section => {
      let btn = document.querySelector(section.id);
      if (btn)
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setTimeout(() => {
            this.getCart();
            this.open();
          }, 1500)

        })
    }))
  }

  getCart() {
    var self = this;
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 & xhr.status == 200) {
        let cart = xhr.responseText;
        //let summaryContainer = document.querySelector('.cart-content-summary');
        let cartNotificationContainer = document.querySelector('.cart-notification');
        var jsonResponse = JSON.parse(xhr.responseText);
        if (jsonResponse.item_count === 0) {         
         cartNotificationContainer.classList.add('emp-cart')
        } else {
          self.renderContents(cart);
          cartNotificationContainer.classList.remove('emp-cart')
        }
      }
    }
    xhr.send()
  }


  renderContents(parsedState) {
    let cart = JSON.parse(parsedState);
    let currentCurrent = theme.moneyFormat.replace('{{amount}}', '');
    let container = document.getElementById('cart-notification-product');
    let cartCounter = document.querySelector('.cart-count[data-cart-count]');

    this.clearCartDrawer(container);

    cart.items.forEach(function (item, index) {

      const containerUpperStart = '<div class="cart-popup-item-up">';
      const productImage = '<img class="ajax-cart-item__image" width="60px" height="60px" alt="' + item.title + '" src="' + item.image + '" >';
      const productPrice = '<div class="ajax-cart-item__price">' + currentCurrent + ((item.line_price * 0.01).toFixed(2)) + '</div>';
      const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
      const containerUpperEnd = '</div><!--1-->';

      const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
      const productRemove = '';

      const concatProductInfo = `<div class="ajax-cart-item__single" data-line="${Number(index + 1)}">
          <div class="cart-popup-item-up"><img class="ajax-cart-item__image" width="60px" height="60px" alt="${item.title}" src="${item.image}">
            <div class="item-info">
              <div class="ajax-cart-item__title">${item.title}</div>
              <div class="ajax-cart-item__price">${currentCurrent + ((item.line_price * 0.01).toFixed(2))}<span class="ajax-cart-item__quantity">(${item.quantity})</span></div>
            </div>
            </div>
          </div>`;

      // const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage + productTitle + productPrice + productQuantity + productRemove + '</div>';


      container.innerHTML = container.innerHTML + concatProductInfo;

      if (cart.item_count != null & cart.item_count != '') {
        container.setAttribute('data-cart-item-count', cart.item_count);
        cartCounter.textContent = cart.item_count;
      }
      cartCounter.textContent = cart.item_count;

    });

  }

  clearCartDrawer(cartDrawerContent) {
    cartDrawerContent.innerHTML = '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: '#cart-icon-bubble'
      }
    ];
  }

  getAddToCartButtons() {
    return [
      {
        id: '.ajax_form_cart'
      },
      {
        id: '.ajax_add_to_cart'
      }
    ];
  }


  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('#cart-icon-bubble') && !target.closest('#cart-notification-popup')) {
      const disclosure = target.closest('site-nav__link--button, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
      document.getElementById('cart-icon-bubble').classList.remove('active');
    }

  }


  setActiveElement(element) {
    this.activeElement = element;
  }

  handleAgreed() {
    if(this.checkoutBtn)
    this.checkoutBtn.addEventListener('click', (e) => {

      setTimeout(() => {
        this.agreedCheckbox.classList.remove('bounce-7');
      }, 150);

      if (this.agreedCheckbox.checked) {
        this.agreedCheckbox.classList.remove('bounce-7');
        this.checkoutBtn.setAttribute('href', '/checkout');
      } else {
        setTimeout(() => {
          this.agreedCheckbox.classList.add('bounce-7');
        }, 250);
      }
    })
  }

  // close button
  handleCloseBtn() {
    var self = this;
    document.querySelector('.cart-notification__close').addEventListener('click', function() {
      if(document.querySelector('#cart-icon-bubble'))
      self.handleActive(document.querySelector('#cart-icon-bubble'));
    })
  }


}

customElements.get('cart-notification-popup') || customElements.define('cart-notification-popup', CartNotification);

